import {
  type SwipeableDrawerProps as MuiSwipeableDrawerProps,
  SwipeableDrawer as MuiSwipeableDrawer,
} from '@mui/material'
import { type DataTestIdAttribute } from '../../types'

type SwipeableDrawerVerticalProps = {
  anchor: 'top' | 'bottom'
  height?: string | number
  minHeight?: string | number
  width?: never
  minWidth?: never
}

type SwipeableDrawerHorizontalProps = {
  anchor?: 'left' | 'right'
  height?: never
  minHeight?: never
  width?: string | number
  minWidth?: string | number
}

export type SwipeableDrawerProps = Pick<
  MuiSwipeableDrawerProps,
  | 'children'
  | 'disableDiscovery'
  | 'disablePortal'
  | 'disableAutoFocus'
  | 'disableBackdropTransition'
  | 'disableRestoreFocus'
  | 'disableSwipeToOpen'
  | 'hysteresis'
  | 'keepMounted'
  | 'minFlingVelocity'
  | 'onClose'
  | 'onOpen'
  | 'onTouchStart'
  | 'open'
  | 'transitionDuration'
  | 'variant'
> & {
  isSwipeable?: boolean
  isFullscreen?: boolean
  swipeCloseMode?: 'modal' | 'handle'
  onBack?: () => void
} & (SwipeableDrawerVerticalProps | SwipeableDrawerHorizontalProps) &
  DataTestIdAttribute

export const SwipeableDrawer = ({ children, isFullscreen, ...props }: SwipeableDrawerProps) => (
  <MuiSwipeableDrawer {...props} className={isFullscreen ? 'DhlDrawer-fullscreen' : undefined}>
    {children}
  </MuiSwipeableDrawer>
)
